module.exports = __webpack_public_path__ + "img/sv22.a3220210.svg";